import { tbAudio } from "./tbAudio";
var tbSound = /** @class */ (function () {
    function tbSound(name, sprite, offset, duration, gain, priority, tags) {
        // Copy the arguments
        this.name = name;
        this.sprite = sprite;
        this.startOffset = offset;
        this.duration = duration;
        tbAudio.setGain(this.name, ((gain !== undefined) ? gain : 1));
        this._priority = (priority !== undefined) ? priority : 10;
        this.tags = [];
        if (tags) {
            this.tags = this.tags.concat(tags);
        }
        if (this.tags.indexOf(this.name) < 0) {
            this.tags.push(this.name);
        }
    }
    tbSound.prototype.complete = function () {
        return this.sprite.complete();
    };
    tbSound.prototype.priority = function (priority) {
        if (priority !== undefined) {
            this._priority = priority;
        }
        return this._priority;
    };
    tbSound.prototype.getTags = function () {
        return this.tags.slice(0);
    };
    tbSound.prototype.addTags = function (tags) {
        for (var t = 0; t < tags.length; t += 1) {
            if (this.tags.indexOf(tags[t]) < 0) {
                this.tags.push(tags[t]);
            }
        }
    };
    tbSound.prototype.removeTags = function (tags) {
        for (var t = 0; t < tags.length; t += 1) {
            var tag = tags[t];
            if (tag !== this.name) {
                var index = this.tags.indexOf(tag);
                if (index >= 0) {
                    this.tags.splice(index, 1);
                }
            }
        }
    };
    return tbSound;
}());
export { tbSound };
